export default __webpack_public_path__ + "static/media/background.058a6ded.png";